import { createSelector } from 'reselect';

const casesState = state => {
  return state.cases;
};

export const getCaseManagerId = createSelector([casesState], data => data.caseManagerId);



// WEBPACK FOOTER //
// ./src/ui/features/Cases/state/casesReselect.js